import React from 'react';
import { Box, Button as MuiButton, Typography, IconButton, Tooltip } from '@mui/material';
import { docGeniusPalette } from 'styles/partials/colors';
import Button from 'components/Button/Button';
import { ModalProps } from '../ModalFactory';
import { CloseRounded } from '@mui/icons-material';
import { useAppDispatch } from 'app/hooks';
import { removePageById } from 'features/document/documentSlice';

export default function DeletePageModalContent(props: ModalProps) {
  const { onClose, modalData } = props;
  const dispatch = useAppDispatch();

  const deletePageById = () => {
    const { pageId } = modalData;
    if (pageId) {
      dispatch(removePageById(pageId));
    }
    onClose();
  };

  return (
    <Box alignItems={'self-end'} display={'flex'} flexDirection={'column'}>
      <Box alignItems={'center'} display={'flex'} justifyContent={'space-between'} width={'100%'}>
        <Typography
          id='modal-modal-title'
          variant='h6'
          component='h2'
          fontSize='24px'
          sx={{ color: docGeniusPalette.neutralGray }}
        >
          Delete Page?
        </Typography>
        <Tooltip title='Close' arrow>
          <IconButton aria-label='' onClick={onClose}>
            <CloseRounded color='primary' />
          </IconButton>
        </Tooltip>
      </Box>
      <Typography id='modal-modal-description' marginTop={'24px'}>
        Deleting this page will remove its content. Are you sure you want to proceed?
      </Typography>
      <Box display={'flex'} gap={'16px'} marginTop={'64px'}>
        <Button variant='secondary' onClick={onClose}>
          Cancel
        </Button>
        <MuiButton
          color='error'
          variant='contained'
          onClick={deletePageById}
          disableElevation
          sx={{ textTransform: 'none' }}
        >
          Delete Page
        </MuiButton>
      </Box>
    </Box>
  );
}
